import type { QueryClient } from '@tanstack/query-core'
import { queryClient } from '@/core/cache/queryClient'

/**
 * What a command needs that is not a module singleton. The Zustand stores are
 * singletons and are imported directly; the QueryClient is passed in so a test
 * can hand over a fresh one instead of sharing the running app's cache.
 */
export type CommandContext = { queryClient: QueryClient }

export function defaultContext(): CommandContext {
  return { queryClient: queryClient as unknown as QueryClient }
}
